import { render, staticRenderFns } from "./TextPopup.vue?vue&type=template&id=4500d8e4&"
import script from "./TextPopup.vue?vue&type=script&lang=ts&"
export * from "./TextPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports